import { Link } from "react-router-dom";
import { IMG } from "@/data/site";

export default function NotFound() {
  return (
    <section data-testid="not-found-page" className="container-x flex min-h-[60vh] flex-col items-center justify-center py-20 text-center">
      <img src={IMG.mark} alt="" className="h-24 w-auto" />
      <h1 className="font-display mt-6 text-4xl text-ink sm:text-5xl">पेज नहीं मिला</h1>
      <p className="font-en mt-2 text-muted2">The page you are looking for doesn't exist.</p>
      <Link to="/" data-testid="not-found-home" className="btn btn-maroon mt-8">होम पेज पर जाएँ</Link>
    </section>
  );
}
